import { Divider } from "@circleco/compass/components/Divider";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface AiPauseDividerProps {
  isPaused: boolean;
}

export const AiPauseDivider = ({ isPaused }: AiPauseDividerProps) => (
  <div className="flex items-center gap-3 py-4">
    <Divider aria-hidden className="flex-1" />
    <div className="flex items-center gap-1.5">
      <Icon
        name={isPaused ? "clock-snooze" : "sparkles"}
        size="sm"
        color="secondary"
      />
      <Typography variant="label-xs" color="secondary">
        {isPaused
          ? t("community_inbox.ai_paused")
          : t("community_inbox.ai_resumed")}
      </Typography>
    </div>
    <Divider aria-hidden className="flex-1" />
  </div>
);
